import type { TersaImageModel } from '../types';
import { providers } from '../../providers';
import { wavespeed } from '../wavespeed';

// 系数
const COST_FACTOR = 1.5;

export const microsoftModels: Record<string, TersaImageModel> = {
    'mai-image-2.5': {
        chef: providers.microsoft,
        providers: [
            {
                ...providers.microsoft,
                model: undefined,
                model_create: wavespeed.image('microsoft/mai-image-2.5/text-to-image'),
                model_edit: wavespeed.image('microsoft/mai-image-2.5/edit'),
                getCost: () => {
                    return 0.05 * COST_FACTOR;
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['21x9', '16x9', '9x16', '5x4', '4x5', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: [],
            },
            i2i: {
                sizes: ['match', '16x9', '9x16', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: [],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 1, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
};